<template>
  <header class="nx-staff-notification-drawer-header">
    <span
      v-if="unreadNotifications"
      class="nx-staff-notification-drawer-header-label"
    >
      {{ unreadNotifications }} {{ $tc('message.common.new', unreadNotifications) }}
    </span>
    <v-spacer />
    <ds-button
      v-if="hasNotifications"
      dark
      icon="check"
      @click="$emit('deleteAll')"
    >
      {{ $t('message.common.deleteAll') }}
    </ds-button>
  </header>
</template>
<script>
import DsButton from '@/design-system/button/DsButton.vue';

export default {
  name: 'NxStaffNotificationDrawerHeader',
  components: { DsButton },
  props: {
    unreadNotifications: {
      type: Number,
      required: true,
    },
    notifications: {
      type: Number,
      required: true,
    },
  },
  computed: {
    hasUnreadNotifications() {
      return this.unreadNotifications > 0;
    },
    hasNotifications() {
      return this.notifications > 0;
    },
  },
};
</script>

<style lang="stylus">
@import "../../../assets/stylus/variables.styl"
.nx-staff-notification-drawer-header {
  display: flex;
  padding: 16px 8px 8px 16px;
  align-items: center;
  gap: 8px;

  &-label {
    color: white;
    font-family: "Roboto";
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 130%;
  }
}
</style>
